import { validate as isValidEmail } from 'email-validator';

const employeeDomains = ['sienna-im.com'];

export default class HAuthLogin {
	/**
	 * True when the login looks like a Sienna employee email. Only decides
	 * whether the employee / investor choice is shown: it grants nothing, real
	 * access control happens after authentication.
	 */
	static isEmployeeEmail(login: string): boolean {
		if (!isValidEmail(login)) {
			return false;
		}
		const domain = login.split('@')[1].toLowerCase();
		return employeeDomains.includes(domain);
	}
}
